import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import {
  DictionaryField,
  DictionaryFieldFromApi,
} from '../../gk-dynamic-list/services/dictionary/dictionary.model';

@Injectable({
  providedIn: 'root',
})
export class VoivodeshipGusDictionaryService {
  private dictionary: Observable<DictionaryField[]>;
  constructor(private httpClient: HttpClient) {}

  get(): Observable<DictionaryField[]> {
    if (!this.dictionary) {
      this.dictionary = this.httpClient
        .get<DictionaryFieldFromApi[]>('/api/emuia/gus/slo/wojewodztwa')
        .pipe(
          map((data) =>
            data.map((fieldFromApi) =>
              DictionaryField.fromApiToApp(fieldFromApi),
            ),
          ),
          shareReplay(1),
        );
    }

    return this.dictionary;
  }
}
